// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetBrandCodeService = {};

AssetBrandCodeService.getAssetBrandCodeList = function (userInput) {
  // console.log("🚀 ~ getAssetBrandCodeList:", userInput);
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/AssetBrand/Items?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

 

export default AssetBrandCodeService;
